import main_1 from "../images/main_1.JPG";
import main_2 from "../images/main_2.jpg";
import main_3 from "../images/main_3.jpg";

export const data = [
  {
    photo: main_1,
    quote:
      "Часто класичний інтер'єр квартири називають нестаріючої класикою. Це справді так, оскільки він у тренді багато років поспіль і не збирається здавати своїх позицій. Він органічний та естетичний, за його допомогою можна створити у приміщенні комфортні та затишні умови.",
  },
  {
    photo: main_2,
    quote:
      "Від планування кухні залежить її функціональність і комфорт. А ось щоб правильно спланувати кухню, необхідно враховувати архітектурні особливості будови, її загальну площу та планування, загальноприйняті стандарти та багато іншого.",
  },
  {
    photo: main_3,
    quote:
      "Краса інтер'єру та рівень комфорту багато в чому залежать від освітлення. Можна просто встановити якісь світильники та не переживати. Але тоді є ймовірність, що в кімнаті, навіть із гарним ремонтом, буде некомфортно. Фактично, будь-який проект дизайнера починається саме з підбору точок освітлення та їх можливостей.",
  },
];
